<template>
    <div class="mt-1">
      <v-container>
          <v-img class="mx-auto" :width="imageWidth" :src="image"/>
          <p  data-testid="no-data-title" class="text-center mb-0 mt-3 text-h4 primary--text ">{{title}}</p> <br>
          <p class="text-center mt-0  text-h5 primary--text font-weight-light" v-if="subtitle">{{subtitle}}</p>
      </v-container>
    </div>
</template>

<script>
    import defaultImage from "@/assets/empty_page.svg";
    export default {
    props: {
        image: {
            type:String,
            default: defaultImage,
        },
        imageWidth: {
            type: Number,
            default: 320
        },
        title:{
            type: String,
            default: 'Page has no data'
        },
        subtitle: String,
    }
    };
</script>
